export enum AnulacionBoletaHonorario {
   "Sin Asignar",
   "No se efectuó el pago de los servicios por parte del receptor",
   "No se efectuó la prestacion de servicios",
   "Error en la digitación",
}
